import { css } from '@emotion/css';
import { WO10, WO30 } from '@julofinance/color-token';

export const subHeaderContainer = css`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.12);
  background: var(--colors-neutrals-10);

  .nav-content {
    display: flex;
    align-items: center;

    svg {
      margin-right: 16px;
      cursor: pointer;
    }
  }

  .help-ticker {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    font-size: 10px;
    line-height: 15px;
    font-weight: bold;
    border-radius: 8px;
    border: 1px solid ${WO30};
    background: ${WO10};
    color: ${WO30};

    svg {
      margin-right: 4px;
    }
  }
`;
